/**
 * @deprecated replace with lodash equivalent
 */
const isObjectType = (value: unknown) => typeof value === "object"
/**
 * @deprecated replace with lodash equivalent
 */
const isNullOrUndefined = (value: unknown): value is null | undefined => value == null
/**
 * @deprecated replace with lodash equivalent
 */
const isUndefined = (val: unknown): val is undefined => val === undefined
/**
 * @deprecated replace with lodash equivalent
 */
const isDateObject = (value: unknown): value is Date => value instanceof Date
/**
 * @deprecated replace with lodash equivalent
 */
const isObject = <T extends object>(value: unknown): value is T =>
    !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value)
/**
 * @deprecated replace with lodash equivalent
 */
const isEmptyString = (str: string): boolean => {
    if (isNullOrUndefined(str)) {
        return true
    }

    return str.trim().length === 0
}
/**
 * @deprecated replace with lodash equivalent
 */
const isEmptyObject = <T extends object>(value: unknown): value is T =>
    !isNullOrUndefined(value) && isObject(value) && Object.keys(value).length === 0

/**
 * Polyfill for lodash.isEmpty
 *
 * @deprecated replace with lodash.isEmpty or corresponding lodash' gate function
 *
 * @param value to check
 * @return boolean
 */
function isEmpty(value: unknown): boolean {
    if (value == null) {
        return true
    }

    if (typeof value === "string" || Array.isArray(value)) {
        return value.length === 0
    }

    if (typeof value === "object") {
        return Object.keys(value).length === 0
    }

    if (value instanceof Map || value instanceof Set) {
        return value.size === 0
    }

    return false
}

export { isObject, isObjectType, isNullOrUndefined, isUndefined, isEmptyString, isEmptyObject, isDateObject, isEmpty }
